const secrets = {
    sentryDSN: 'https://11ff06bc986e46aaa40d5ea406a14aaa@sentry.io/144904',
    mapillary4: 'MLY|5134371116619832|9a5949fa0d3bba986c5202c54c884f53',
    google: '',
    mapyCzKey: 'vFR3CE_ie8Qz36UFgcnvl7ol8sipmgIMexi3KT15XSw',
};

export default secrets;
